<template>
    <div class="container boxShadow">
        <h5>网上报名</h5>
        <div class="cont">
            <div class="item boxShadow" v-for="item in arr">
                <div class="images">
                    <img src="../../public/images/em.jpg" alt="">
                    <span class="tags">百姓时尚秀</span>
                </div>
                <div class="content">
                    <h5>“映画时光“市南区国庆微演艺</h5>
                    <p>活动时间：2019年06月29日~2019年07月02日</p>
                    <p>活动地点：青岛大剧院 崂山区云岭路5号</p>
                    <div class="icons">
                        <span class="icon-view">699</span>
                        <span class="icon-zan">699</span>
                        <span class="icon-star">699</span>
                    </div>
                    <div class="btn btn-primary hoverable">
                        <div class="anim"></div>
                        报名中
                    </div>
                </div>
            </div>

        </div>
        <div class="user_center" @click="$router.push('/account')">
            个人中心
        </div>
    </div>
</template>

<script scoped>
    export default {
        props: {

        },
        data() {
            return {
                arr: [1, 2, 3, 4, 5]
            };
        },
        computed: {

        },
        created() {

        },
        mounted() {

        },
        watch: {

        },
        methods: {

        },
        components: {

        },
    };
</script>

<style scoped>
    .container {
        background: #ffffff;
        padding: 40px;
    }

    .container>h5 {
        font-size: 1.3em;
        color: #333333;
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .cont {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 22px;
    }

    .item .images {
        position: relative;
        overflow: hidden;
    }
    .item .images img{
        width: 100%;
    }
    .item {
        width: 22%;
        margin-right: 4%;
        margin-bottom: 20px;
    }

    .item:nth-child(4n) {
        margin-right: 0;
    }

    .item .content {
        padding: 10px;
    }

    .item .content h5 {
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #333;
        font-size: 0.9em;
        font-weight: bold;
    }

    .item .content p {
        font-size: 0.7em;
        color: #8c8c8c;
    }

    .icons {
        display: flex;
        justify-content: space-between;
        align-content: center;
        font-size: 0.8em;
        margin: 1em 0;
        padding: 0 5px;
    }

    .icons>span {
        min-width: 30px;
    }

    .tags {
        position: absolute;
        transform-origin: 50% 50%;
        transform: rotate(-45deg);
        width: 120px;
        left: -28px;
        top: 17px;
        font-size: 0.8em;
        text-align: center;
        color: #f0f8fe;
    }

    .item:nth-child(4n+1) .tags {
        background: linear-gradient(to right, #e3071f, #fa7180);
    }

    .item:nth-child(4n+2) .tags {
        background: linear-gradient(to right, #063a9f, #27aefc);
    }

    .item:nth-child(4n+3) .tags {
        background: linear-gradient(to right, #ff3f04, #fc8c6a);
    }

    .item:nth-child(4n+4) .tags {
        background: linear-gradient(to right, #750ada, #b76dfb);
    }
    .item:hover{
        box-shadow: 0 5px 10px #cde6ff
    }
    @media only screen and (max-width: 750px){
        .container>h5{font-size: 1em;padding-bottom: 0.1rem}
        .cont .item{width: 100%;margin-right: 0;}
        .container{padding: 0.2rem;}
    }
</style>